module.exports = __webpack_public_path__ + "img/theme9.d17684be.png";